function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1372e80c-4430-4cc4-9565-898cb64aedf8",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m25.917,12.74h-5.294c-.828,0-1.5.671-1.5,1.5s.672,1.5,1.5,1.5h3.794v10.9H7.583v-10.9h3.794c.828,0,1.5-.671,1.5-1.5s-.672-1.5-1.5-1.5h-5.294c-.828,0-1.5.671-1.5,1.5v13.9c0,.829.672,1.5,1.5,1.5h19.833c.828,0,1.5-.671,1.5-1.5v-13.9c0-.829-.672-1.5-1.5-1.5Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5,21.591c0,.829.672,1.5,1.5,1.5s1.5-.671,1.5-1.5v-9.906h3.885l-5.385-9.326-5.385,9.326h3.885v9.906Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.02aba6357a1d4202b613a0919a6f62e0.svg";
export { ForwardRef as ReactComponent };